// ==========================================================================
// Northpeak: meten op vylento.com
//
// Loaded from layout/theme.liquid (block "NORTHPEAK: METEN"), deferred and
// cached, so it costs a visitor nothing on the second page. What it does and
// why is explained there and below, section by section.
// ==========================================================================
  (function () {
    if (!window.performance || !performance.getEntriesByType) return;

    var ENDPOINT = "https://vpggkzkxxgeboxptxzgw.supabase.co/functions/v1/web-pixel-ingest";
    var TOKEN = "XSB4CuMqa4WDgNtG0Xr78PgRHEmNq4WY";
    var lcp = null;

    // window.northpeakLog(stream, data, sessionId): one JSON row for Web
    // Analytics > Dashboards (the quiz uses it). The pixel's visit id rides
    // along when there is one, so a row can be tied to the visit it came from.
    window.northpeakLog = function (stream, data, sessionId) {
      try {
        var row = JSON.parse(JSON.stringify(data || {}));
        var v = ids();
        if (v) row.npSessionId = v.sid;
        var sid = sessionId ? String(sessionId) : null;
        fetch(ENDPOINT, {
          method: "POST",
          keepalive: true,
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify({
            token: TOKEN,
            stream: stream,
            events: [{ event_id: (sid || "anon") + "|" + Date.now(), session_id: sid, data: row }],
          }),
        }).catch(function () {});
      } catch (e) {}
    };

    // LCP is not final until the visitor leaves or interacts: the largest
    // element can still be replaced by a larger one halfway down the page.
    try {
      var po = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        if (entries.length) lcp = Math.round(entries[entries.length - 1].startTime);
      });
      po.observe({ type: "largest-contentful-paint", buffered: true });
    } catch (e) {}

    // This visit's session and visitor id, read from the first-party cookie the
    // Northpeak pixel writes (see shareIds() in the sandbox code above). Shared
    // by the exit beacon below, add-to-cart and the click map: no cookie means
    // the pixel is not running or is blocked by consent, and each of those
    // stays silent rather than invent a visit to attach to.
    //
    // The cookie is written from the pixel SANDBOX, asynchronously, on that
    // visit's first event. This page can therefore reach pagehide before it
    // lands -- and the faster the visitor leaves, the likelier that is. Measured
    // 3 Sep: of the visits that reported no exit at all, 1 in 40 had a click,
    // against 77% of the visits that did. The clicks come from this same block
    // and the same cookie, so that gap is not behaviour, it is a race — and it
    // was silently eating exactly the quick departures a bounce curve is about.
    //
    // So the ids are cached the moment they first appear, and looked for during
    // the opening seconds rather than only when they are needed. A fresh cookie
    // still wins over the cache: a visit that idles past the session window gets
    // a new id, and the exit belongs to that one, not to the one we remembered.
    var cachedIds = null;
    function ids() {
      var m = /(?:^|;\s*)np_id=([^;]+)/.exec(document.cookie || "");
      if (m) {
        var parts = decodeURIComponent(m[1]).split(".");
        if (parts.length === 2 && parts[0] && parts[1]) {
          cachedIds = { sid: parts[0], vid: parts[1] };
          return cachedIds;
        }
      }
      return cachedIds;
    }

    // Six seconds of looking, then stop: past that the cookie is not coming,
    // and a timer that never clears is its own kind of bug.
    (function () {
      var tries = 0;
      var iv = setInterval(function () {
        if (ids()) { clearInterval(iv); sendAbExposures(); }
        else if (++tries > 40) clearInterval(iv);
      }, 150);
    })();

    // ---- which A/B arm this visitor saw ---------------------------------
    //
    // The head script (top of <head>) put this browser in an arm for every
    // running Northpeak A/B test on this page. This tells Northpeak, once per
    // test per visit, with the visit's ids so the result can be read from the
    // same sessions as everything else. No pixel cookie, no report: the
    // visitor still sees their arm, they just are not counted.
    //
    // Which Intelligems test and group the browser is in rides along, plus their
    // names when Intelligems has loaded, so the result can be read per group.
    // Intelligems names its tests only once its own script has run, which is
    // often after the pixel cookie lands. Up to four seconds of waiting for it,
    // then the exposure goes without names: the ids alone still split the result.
    var abWaits = 0;
    function sendAbExposures() {
      var ab = window.npab;
      var id = ids();
      if (!ab || !id || !ab.tests.length) return;
      var igReady = window.igData && window.igData.user && window.igData.user.getExperiments;
      if (!igReady && Object.keys(ab.ig).length && abWaits++ < 20) { setTimeout(sendAbExposures, 200); return; }
      var names = [];
      try {
        var u = window.igData && window.igData.user;
        (u && u.getExperiments ? u.getExperiments() : []).forEach(function (x) {
          var full = String(x.id || "");
          var short = full.replace(/-/g, "").slice(-12);
          if (x.name) names.push({ kind: "test", id: short, name: String(x.name) });
          var g = ab.ig[short];
          var gName = null;
          try { gName = g && u.getVariationName ? u.getVariationName(full) : null; } catch (e) {}
          if (g && gName) names.push({ kind: "group", id: g, name: String(gName) });
        });
      } catch (e) {}
      var events = [];
      ab.tests.forEach(function (k) {
        var arm = ab.arms[k];
        if (!/^[a-e]$/.test(arm || "")) return;
        var flag = "npab_sent_" + k + "_" + ab.pid + "_" + id.sid;
        try { if (sessionStorage.getItem(flag)) return; sessionStorage.setItem(flag, "1"); } catch (e) {}
        events.push({
          event_id: "ab" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10),
          name: "ab_exposure",
          ts: new Date().toISOString(),
          test: k,
          product_id: ab.pid,
          lang: ab.lang,
          country: ab.country,
          arm: arm,
          ab_id: ab.id,
          session_id: id.sid,
          visitor_id: id.vid,
          ig: ab.ig,
          ig_names: names
        });
      });
      if (!events.length) return;
      try {
        navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify({ token: TOKEN, events: events })], { type: "text/plain" }));
      } catch (e) {}
    }

    // ---- how far down the page they got ---------------------------------
    //
    // A page can be read to the bottom or abandoned above the fold, and both
    // count as one view. The deepest point reached is the difference, and it is
    // only final when the visitor leaves -- which is exactly when the beacon
    // below already fires, so this rides along and costs no extra request.
    var maxScroll = 0;
    var scrollable = 0;
    var ticking = false;

    function measureHeight() {
      var h = document.documentElement;
      var body = document.body;
      scrollable =
        Math.max(h.scrollHeight || 0, (body && body.scrollHeight) || 0) - window.innerHeight;
    }

    function sampleScroll() {
      ticking = false;
      // Nothing to scroll means the whole page was on screen, so it was seen in
      // full. Reporting 0% for a short page would say the opposite.
      if (scrollable <= 0) { maxScroll = 100; return; }
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var pct = Math.round((y / scrollable) * 100);
      if (pct > 100) pct = 100;
      if (pct < 0) pct = 0;
      if (pct > maxScroll) maxScroll = pct;
    }

    // The height is read on load and resize only, never per scroll event:
    // scrollHeight forces the browser to lay the page out, and doing that on
    // every pixel of scrolling is how an analytics snippet makes a site feel
    // slow while measuring how slow the site feels.
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sampleScroll);
    }
    addEventListener("scroll", onScroll, { passive: true });
    addEventListener("resize", function () { measureHeight(); onScroll(); }, { passive: true });
    addEventListener("load", function () { measureHeight(); sampleScroll(); });
    measureHeight();
    sampleScroll();

    // ---- the count, sent immediately ------------------------------------
    //
    // Everything else in this block is sent when the visitor LEAVES, because
    // that is when the numbers are final. That is also the beacon most likely
    // to be lost: close the tab fast enough and it never goes.
    //
    // So the COUNT leaves now, on its own, carrying nothing but the page and
    // the moment. No identifier, no session, no cookie — it answers "someone
    // opened this page" and refuses to answer anything else. It is what makes
    // the traffic figures complete where the consented ones cannot be.
    (function () {
      try {
        var body = JSON.stringify({
          token: TOKEN,
          events: [{
            event_id: "l" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10),
            name: "page_load",
            ts: new Date().toISOString(),
            path: location.pathname + location.search
          }]
        });
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
      } catch (e) {}
    })();

    /*
      Northpeak A/B tests, counted over every visitor rather than only those
      who gave consent:
      * one anonymous visit per test product per visit, like the page_load
        count above: test, version, product and market, no id of any kind;
      * the versions this browser was shown go onto its cart as the attribute
        _npab ("<test key>=<version>,..."), so the order carries them, the same
        way Intelligems puts igTestGroups on the cart. Only our own attribute is
        written; cart/update.js leaves every other attribute as it is. Written
        once the cart exists and again after each add, only when it changed.
    */
    (function () {
      var ab = window.npab;
      if (!ab || !ab.tests || !ab.tests.length) return;
      var views = [];
      ab.tests.forEach(function (k) {
        var arm = ab.arms[k];
        if (!/^[a-e]$/.test(arm || "")) return;
        var flag = "npab_v_" + k + "_" + ab.pid;
        try { if (sessionStorage.getItem(flag)) return; sessionStorage.setItem(flag, "1"); } catch (e) {}
        views.push({
          event_id: "v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10),
          name: "ab_view",
          test: k,
          arm: arm,
          product_id: ab.pid,
          lang: ab.lang,
          country: ab.country
        });
      });
      if (!views.length) return;
      try {
        navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify({ token: TOKEN, events: views })], { type: "text/plain" }));
      } catch (e) {}
    })();
    (function () {
      var post = window.fetch;
      if (!post) return;
      function versions() {
        var m = /(?:^|;\s*)np_ab=([^;]*)/.exec(document.cookie || "");
        var raw = m ? decodeURIComponent(m[1]) : "";
        if (!raw) { try { raw = localStorage.getItem("np_ab") || ""; } catch (e) {} }
        return (raw.split("|")[1] || "").split(",").filter(function (p) {
          return /^[a-z0-9]{4,16}=[a-e]$/.test(p);
        }).join(",");
      }
      function sync() {
        var v = versions();
        var c = /(?:^|;\s*)cart=([^;]*)/.exec(document.cookie || "");
        if (!v || !c) return;
        var done = v + "|" + c[1];
        try { if (sessionStorage.getItem("npab_cart") === done) return; } catch (e) {}
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
        post.call(window, root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { _npab: v } })
        }).then(function (r) {
          if (r.ok) { try { sessionStorage.setItem("npab_cart", done); } catch (e) {} }
        }).catch(function () {});
      }
      sync();
      window.fetch = function () {
        var args = arguments;
        var out = post.apply(this, args);
        try {
          var u = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
          if (u.indexOf("/cart/add") > -1) out.then(function () { setTimeout(sync, 0); }, function () {});
        } catch (e) {}
        return out;
      };
    })();

    var sent = false;
    function send() {
      if (sent) return;
      var nav = performance.getEntriesByType("navigation")[0];
      if (!nav) return;
      sent = true;

      var body = JSON.stringify({
        token: TOKEN,
        events: [{
          event_id: "t" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10),
          name: "page_timing",
          ts: new Date().toISOString(),
          path: location.pathname + location.search,
          ttfb_ms: Math.round(nav.responseStart) || null,
          lcp_ms: lcp,
          load_ms: Math.round(nav.loadEventEnd) || null,
          scroll_pct: maxScroll
        }]
      });

      // text/plain on purpose: it is a CORS-safelisted content type, so the
      // beacon goes straight out. With application/json the browser would want
      // a preflight, and sendBeacon cannot do one -- the call would simply be
      // dropped. The endpoint parses the body either way.
      try {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
      } catch (e) {
        try {
          fetch(ENDPOINT, {
            method: "POST", keepalive: true,
            headers: { "content-type": "text/plain" }, body: body
          });
        } catch (e2) {}
      }
    }

    // ---- when they actually left ------------------------------------------
    //
    // One event, timestamped at the real moment of departure, sent WITH this
    // visit's session id. Session duration in the rollup is just
    // max(occurred_at) - min(occurred_at) over a session's events, so this is
    // all it takes to turn that from a floor rounded to one of two heartbeats
    // into the true second someone left -- for a three-second bounce as much as
    // for a three-minute read.
    //
    // Sent again when someone comes back and leaves a second time. Hiding a tab
    // is not the same as closing it: a visitor who glances away after ten
    // seconds and then reads for five minutes was, under a one-shot beacon,
    // filed as a ten-second visit. The rollup takes the LAST timestamp of the
    // session, so a later exit simply corrects the earlier one. Capped at four,
    // because someone flicking between tabs should not pay for it by the event.
    var exitsSent = 0;
    var exitPending = true;
    function sendExit() {
      if (!exitPending || exitsSent >= 4) return;
      var id = ids();
      if (!id) return;
      exitPending = false;
      exitsSent++;
      var body = JSON.stringify({
        token: TOKEN,
        events: [{
          event_id: "x" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10),
          session_id: id.sid,
          visitor_id: id.vid,
          name: "page_exit",
          ts: new Date().toISOString(),
          path: location.pathname + location.search
        }]
      });
      try {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
      } catch (e) {
        try {
          fetch(ENDPOINT, {
            method: "POST", keepalive: true,
            headers: { "content-type": "text/plain" }, body: body
          });
        } catch (e2) {}
      }
    }

    // ---- how long the page was looked at, for everyone --------------------
    //
    // The exit above rides on the np_id cookie, and the pixel only writes that
    // once someone has accepted analytics -- so every duration on the Bounce
    // tab describes a bit over half the room, and the half that says no is
    // invisible. This event needs nothing from them: it carries the number of
    // seconds the page was VISIBLE and no identity at all. No cookie, no
    // localStorage, nothing read from or written to the device, no session, no
    // visitor, no way back to a person. That is what lets it run before the
    // banner is answered instead of after.
    //
    // VISIBLE seconds, not wall clock. A tab sitting in the background is not
    // being read, and counting it is exactly the mistake the consented figure
    // has to be corrected for on the way in.
    var visibleMs = 0;
    var visibleSince = document.visibilityState === "hidden" ? null : Date.now();

    // One id per PAGE VIEW, held in a variable and written nowhere. It is here
    // so that leaving twice reports ONE page view with the larger number rather
    // than two page views: the rollup keeps the highest count per id. It dies
    // with the page and means nothing to the next one.
    var dwellId = "d" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    var dwellsSent = 0;

    // Hiding a tab and unloading it both count as leaving, and a real departure
    // fires BOTH within the same tick -- measured on the first live traffic:
    // every report arrived twice with an identical count. Reporting once per
    // departure and re-arming on the way back keeps the four to four actual
    // departures instead of two. Same guard the exit above uses.
    var dwellPending = true;

    function sendDwell() {
      if (!dwellPending || dwellsSent >= 4) return;
      dwellPending = false;
      if (visibleSince !== null) {
        visibleMs += Date.now() - visibleSince;
        visibleSince = null;
      }
      dwellsSent++;
      var body = JSON.stringify({
        token: TOKEN,
        events: [{
          event_id: dwellId,
          name: "page_dwell",
          ts: new Date().toISOString(),
          path: location.pathname + location.search,
          dwell_s: Math.round(visibleMs / 1000)
        }]
      });
      try {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
      } catch (e) {
        try {
          fetch(ENDPOINT, {
            method: "POST", keepalive: true,
            headers: { "content-type": "text/plain" }, body: body
          });
        } catch (e2) {}
      }
    }

    // Whichever comes first: the visitor leaves the tab, the page is unloaded,
    // or ten seconds pass on a page they are still reading. Coming back arms the
    // exit again, so the visit is dated by the last time they left rather than
    // the first time they looked away.
    addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") { send(); sendExit(); sendDwell(); }
      else {
        exitPending = true;
        dwellPending = true;
        if (visibleSince === null) visibleSince = Date.now();
      }
    });
    addEventListener("pagehide", function () { send(); sendExit(); sendDwell(); });
    addEventListener("load", function () { setTimeout(send, 10000); });

    // ---- add to cart -----------------------------------------------------
    //
    // This is here rather than in the pixel because the pixel cannot see it.
    // Shopify's product_added_to_cart covers a single-item add; a theme that
    // posts an items[] array -- a bundle block, a sticky bar, an add-on picker
    // -- produces no event at all, so the step reads a permanent zero while the
    // cart fills perfectly well. Watching the request catches every route.
    //
    // It only OBSERVES: it calls through untouched and never inspects, blocks or
    // rewrites anything. Other wrappers on this page do transform the body, and
    // this one runs after them, so it sees what was actually sent.
    (function () {
      if (!window.fetch) return;

      // The line total in currency units. Shopify answers in cents and spreads
      // the amount over several fields depending on the call and the API
      // version, so take the first that is actually a number above zero, and
      // fall back to unit price times quantity, which is always present.
      function money(it) {
        var candidates = [it.line_price, it.final_line_price, it.original_line_price];
        for (var i = 0; i < candidates.length; i++) {
          var c = Number(candidates[i]);
          if (Number.isFinite(c) && c > 0) return c / 100;
        }
        var unit = Number(it.price != null ? it.price : it.final_price);
        var qty = Number(it.quantity) || 1;
        if (Number.isFinite(unit) && unit > 0) return (unit * qty) / 100;
        return null;
      }

      function report(items) {
        // No cookie means the pixel is not running, or is blocked by consent.
        // Then this stays silent: an add-to-cart with an invented visit would
        // be worse than none at all.
        var id = ids();
        if (!id || !items || !items.length) return;

        var events = items.map(function (it, i) {
          return {
            event_id: "atc" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8) + i,
            session_id: id.sid,
            visitor_id: id.vid,
            name: "add_to_cart",
            ts: new Date().toISOString(),
            path: location.pathname,
            // Shapes straight from /cart/add.js: the id field is the
            // VARIANT, the product sits on product_id, money comes in cents.
            product_id: it.product_id != null ? String(it.product_id) : null,
            variant_id: it.id != null ? String(it.id) : null,
            sku: it.sku || null,
            quantity: it.quantity || 1,
            // Money, in cents, from whichever field this response actually
            // carries. Reading line_price alone gave 0.00 on a EUR 49.90 line
            // in the very first live test -- the field exists but is not always
            // the one filled in, and a silent zero is worse than a null.
            value: money(it),
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null
          };
        });

        try {
          fetch(ENDPOINT, {
            method: "POST", keepalive: true,
            headers: { "content-type": "text/plain" },
            body: JSON.stringify({ token: TOKEN, events: events })
          });
        } catch (e) {}
      }

      // ---- where the finger landed ---------------------------------------
      //
      // Position, not just the target. The most telling clicks on a page are
      // usually the ones that were not links at all: a product image everybody
      // taps expecting a zoom, a heading that reads like a tab. A list of
      // buttons pressed can never show those, and they are exactly the friction
      // a heatmap is for.
      //
      // Recorded as PROPORTIONS -- x as a percent of the viewport width, y as a
      // permille of the whole document -- because the screenshot they will be
      // drawn over is never the visitor's own screen width.
      var clicks = [];

      // What was under it, in words. Read the nearest thing a person would say
      // they clicked: a button, a link, an image's alt text. It makes the map
      // readable before any screenshot exists, and it survives a redesign that
      // moves the button.
      function labelOf(el) {
        try {
          var node = el;
          for (var i = 0; i < 5 && node && node !== document.body; i++) {
            var tag = (node.tagName || "").toLowerCase();
            if (tag === "button" || tag === "a" || tag === "summary" ||
                node.getAttribute && node.getAttribute("role") === "button") {
              var t = (node.innerText || node.textContent || "").replace(/\s+/g, " ").trim();
              if (t) return t.slice(0, 60);
              var aria = node.getAttribute && node.getAttribute("aria-label");
              if (aria) return aria.slice(0, 60);
              return tag;
            }
            if (tag === "img") {
              var alt = node.getAttribute && node.getAttribute("alt");
              return alt ? ("image: " + alt).slice(0, 60) : "image";
            }
            node = node.parentElement;
          }
          var own = (el.innerText || el.textContent || "").replace(/\s+/g, " ").trim();
          return own ? own.slice(0, 60) : ((el.tagName || "").toLowerCase() || null);
        } catch (e) { return null; }
      }

      addEventListener(
        "click",
        function (ev) {
          try {
            // Not a real pointer: keyboard activation and synthetic clicks from
            // scripts have no coordinates, and plotting them at 0,0 would put a
            // permanent hot spot in the top-left corner of every page.
            if (!ev.isTrusted || (!ev.clientX && !ev.clientY)) return;
            if (clicks.length >= 40) return;

            var docH = Math.max(
              document.documentElement.scrollHeight || 0,
              (document.body && document.body.scrollHeight) || 0
            );
            if (!docH || !window.innerWidth) return;

            clicks.push({
              x: Math.round((ev.clientX / window.innerWidth) * 100),
              y: Math.round((ev.pageY / docH) * 1000),
              label: labelOf(ev.target),
              t: new Date().toISOString()
            });
          } catch (e) {}
        },
        { passive: true, capture: true }
      );

      function reportClicks() {
        var id = ids();
        if (!id || !clicks.length) return;
        var batch = clicks.splice(0, 40);
        var events = batch.map(function (c, i) {
          return {
            event_id: "c" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8) + i,
            session_id: id.sid,
            visitor_id: id.vid,
            name: "click",
            ts: c.t,
            path: location.pathname,
            click_x: c.x,
            click_y: c.y,
            click_label: c.label
          };
        });
        try {
          var body = JSON.stringify({ token: TOKEN, events: events });
          navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
        } catch (e) {}
      }

      // Sent when the visitor leaves, alongside the timing beacon: one request
      // per page view carrying the whole batch, rather than one per click.
      addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") reportClicks();
      });
      addEventListener("pagehide", reportClicks);

      var passThrough = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = args[0];
        var isAdd = false;
        try {
          var s = typeof url === "string" ? url : (url && url.url) || "";
          isAdd = s.indexOf("/cart/add") > -1;
        } catch (e) {}

        var out = passThrough.apply(this, args);
        if (!isAdd) return out;

        return out.then(function (response) {
          // The response is read from a clone, so the theme still gets an
          // untouched, unread body. Reading the original would break the cart.
          try {
            if (response && response.ok) {
              response.clone().json().then(function (data) {
                // /cart/add.js answers with the added line for a single add, or
                // {items:[...]} for a multi-add. Both shapes, one path.
                var lines = data && data.items ? data.items : (data && data.id ? [data] : []);
                report(lines);
              }).catch(function () {});
            }
          } catch (e) {}
          return response;
        });
      };
    })();
  })();
